// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Home from './pages/Home';
// import About from './pages/About';
// import Products from './pages/Products';
// import Contact from './pages/Contact';
// import BloodPressure from './pages/BloodPressure'; // Import the subpage
// import Product1 from './pages/Product1';
// import BloodPressure2 from './pages/BloodPressure2';
// import Gallery from './pages/Gallery';
// import BloodGlucose2 from './pages/BloodGlucos2';
// import BloodGlucose from './pages/BloodGlucose';
// import BloodHemoglobin from './pages/BloodHemoglobin';
// import BloodHemoglobin2 from './pages/BloodHemoglobin2';
// import ScrollToTop from './components/ScrollToTop';
// const App = () => {
//   return (
    
//     <Router>
//        <ScrollToTop/>
//       <div>
//         <Routes>
         
//           <Route path="/" element={<Home />} />
//           <Route path="/about" element={<About />} />
//           <Route path="/products" element={<Products />} />
//           <Route path="/product1" element={<Product1 />} />
//           <Route path="/blood-pressure-meter" element={<BloodPressure />} />
//           <Route path="/blood-pressure-meter-plus" element={<BloodPressure2 />} />
//           <Route path="/Blood-glucose-meter-plus" element={<BloodGlucose2/>} />
//           <Route path="/Hemoglobin-meter" element={<BloodHemoglobin />} />
//           <Route path="/Hemoglobin-meter-plus" element={<BloodHemoglobin2/>} />
//           <Route path="/blood-glucose-meter" element={<BloodGlucose/>} /> {/* Closing tag added here */}
//           <Route path="/gallery" element={<Gallery />} />
//           <Route path="/contact" element={<Contact />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;


import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Page Imports
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Contact from './pages/Contact';
import BloodPressure from './pages/BloodPressure';
import Product1 from './pages/Product1';
import BloodPressure2 from './pages/BloodPressure2';
import Gallery from './pages/Gallery';
import BloodGlucose from './pages/BloodGlucose';
import BloodGlucose2 from './pages/BloodGlucos2';
import BloodHemoglobin from './pages/BloodHemoglobin';
import BloodHemoglobin2 from './pages/BloodHemoglobin2';
import ScrollToTop from './components/ScrollToTop';

const App = () => {
  return (
    <Router>
      <Helmet>
        <title>DrChek - Healthcare Devices & Monitoring Solutions</title>
        <meta
          name="description"
          content="Explore DrChek's range of smart healthcare and diagnostic devices. Glucose meters, BP monitors, hemoglobin analyzers and more."
        />
        <meta
          name="keywords"
          content="DrChek, Healthcare Devices, Blood Glucose Monitor, Blood Pressure Monitor, Hemoglobin Analyzer, Smart Health"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="UTF-8" />
        <link rel="canonical" href="https://www.drchek.com/" />
      </Helmet>

      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product1" element={<Product1 />} />
        <Route path="/blood-pressure-meter" element={<BloodPressure />} />
        <Route path="/blood-pressure-meter-plus" element={<BloodPressure2 />} />
        <Route path="/blood-glucose-meter" element={<BloodGlucose />} />
        <Route path="/Blood-glucose-meter-plus" element={<BloodGlucose2 />} />
        <Route path="/Hemoglobin-meter" element={<BloodHemoglobin />} />
        <Route path="/Hemoglobin-meter-plus" element={<BloodHemoglobin2 />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
};

export default App;
